<template>
  <div>
    <div class="purchase-package-body">
      <b-row>
        <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
          <div class="filter-wrapper">
            <b-form-select v-model="selected" :options="options"></b-form-select>
          </div>
        </b-col>
        <b-col></b-col>
        <b-col md="4">
          <div class="text-right">
            <b-button
              variant="primary"
              class="d-inline-block new-button align-top mr-3"
              @click="showModal('new-purchase-package')"
            >+ New Card Bundle</b-button>
            <b-button
              @click="toggleViewList"
              variant="outline-secondary"
              class="d-inline-block new-button align-top"
              style="font-family: MainFontBold, sans-serif;"
            >
              <div v-if="viewList">View Top 20</div>
              <div v-else>View List</div>
            </b-button>
          </div>
          <AddPurchasePackage
            :logoStamp="form.logoStamp"
            @clearImageLogoStamp="clearPackageImgLogoStamp"
          ></AddPurchasePackage>
          <EditPurchasePackage
            :form="purchasePackageDetails"
            :logoStamp="form.logoStamp"
            @clearImageLogoStamp="clearPackageImgLogoStamp"
          ></EditPurchasePackage>
          <AddMembers :purchasePackageUuid="purchasePackageUuid"></AddMembers>
          <Members :purchasePackageUuid="purchasePackageUuid" :members="members"></Members>
          <MismatchRows :open="mismatch" />
        </b-col>
      </b-row>
      <div
        class="mt-3 mb-4 pb-3"
        v-bind:class="{ 'scrolling-wrapper-flexbox': viewList, 'wrapper-flexbox': !viewList }"
      >
        <template v-if="topPurchasePackages.length > 0">
          <div
            class="box mr-3 p-3"
            v-for="(topPurchasePackage, index) in topPurchasePackages"
            v-bind:key="index"
            v-bind:class="{ 'mb-3': !viewList }"
          >
            <b-row no-gutters>
              <b-col>
                <div style="height: 26px;">
                  <switches
                    v-model="topPurchasePackage.visibility"
                    theme="custom"
                    color="primary"
                    type-bold="true"
                    text-enabled="On"
                    text-disabled="Off"
                    style="top: -20px;"
                    :emit-on-mount="false"
                    disabled
                  ></switches>
                </div>
              </b-col>
              <b-col class="text-right align-middle">
                <img
                  src="../../assets/images/actions/edit.svg"
                  alt="Edit Button"
                  class="action-button ml-1"
                  @click="confirmEdit(topPurchasePackage.uuid)"
                />
                <img
                  src="../../assets/images/actions/delete.svg"
                  alt="Delete Button"
                  class="action-button ml-1"
                  @click="callDelete(topPurchasePackage.uuid, topPurchasePackage.title)"
                />
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col>
                <div id="purchase-package-badge" class="border rounded-circle mx-auto mt-3">
                  <img :src="topPurchasePackage.logo" alt="Logo" style="object-fit: contain;" />
                </div>
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col>
                <div class="box-body text-center">
                  <h3 class="heading">{{ topPurchasePackage.title }}</h3>
                  <p class="description mb-2">{{ topPurchasePackage.description }}</p>
                  <p class="members mb-2">
                    <strong>{{ topPurchasePackage.no_members }}</strong> Members
                  </p>
                  <p class="price mb-2">Php {{ topPurchasePackage.price | priceFormatter }}</p>
                  <p
                    class="expiration mb-2"
                  >{{ topPurchasePackage.validity_duration }} {{ topPurchasePackage.validity_type | validityFormatter }} Validity</p>
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
        <template v-else>
          <div class="box mr-3 p-3">
            <b-row>
              <b-col>
                <div class="empty-purchase-package text-center mt-3">
                  <h2>Create Card Bundle</h2>
                  <img
                    class="add-button d-block mx-auto mt-2"
                    src="../../assets/images/icons/add.svg"
                    alt="Add Icon"
                    @click="showModal('new-purchase-package')"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
      </div>
      <div v-bind:class="{ 'd-none': !viewList }">
        <h2 class="sub-heading mb-3">Card Bundles</h2>
        <div>
          <b-row>
            <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-form-select v-model="selectedPurchasePackage" :options="purchasePackageOptions" @input="filterCardBundles()" />
              </div>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-input-group prepend>
                  <b-form-input
                    placeholder="Search"
                    v-model="searchKeyword"
                  ></b-form-input>
                  <b-dropdown text="Advanced" variant="primary" slot="append">
                    <b-dropdown-item
                      v-for="searchField in searchableFields"
                      :key="searchField.value"
                      @click="selectedSearchOption = searchField.value"
                    >
                      {{ searchField.text }}
                      <i
                        v-if="selectedSearchOption === searchField.value"
                        class="ml-1"
                      >
                        <img
                          width="15"
                          height="15"
                          src="@/assets/images/checked-symbol.svg"
                          alt
                          class="mr-1"
                          style="margin-top: -2px; margin-right: 0px;"
                        />
                      </i>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </div>
            </b-col>
            <b-col class="text-left text-md-right">
              <b-button variant="primary btn-table-export" @click="exportPurchasePackages()">Export</b-button>
            </b-col>
          </b-row>
        </div>
        <div>
          <div class="data-container">
            <b-table
                responsive
                :items="purchasePackages"
                :fields="fields"
                show-empty
                :empty-text="(loading) ? 'Loading data' : 'No Records Found'"
            >
              <template slot="price" slot-scope="data">{{ data.value | priceFormatter }}</template>
              <template
                slot="validity"
                slot-scope="data"
              >{{ data.item.validity_duration }} {{ data.item.validity_type | validityFormatter }}</template>
              <template slot="visibility" slot-scope="data">
                <div v-if="data.item.visibility" class="active-status">Active</div>
                <div class="inactive-status" v-else>Inactive</div>
              </template>
              <template slot="uuid" slot-scope="data">
                <b-row no-gutters>
                  <i class="action-button ml-2">
                    <img
                      src="@/assets/images/actions/members.svg"
                      alt="Members Button"
                      style="margin-top: 4px; margin-right: 4px;"
                      @click="showMembers(data.item.uuid)"
                    />
                  </i>
                  <i class="action-button ml-2">
                    <img
                      src="@/assets/images/actions/edit.svg"
                      alt="Edit Button"
                      @click="confirmEdit(data.item.uuid)"
                    />
                  </i>
                  <i class="action-button ml-2">
                    <img
                      src="@/assets/images/actions/export_grey.svg"
                      alt="Export Button"
                      @click="showAddMembers(data.item.uuid)"
                    />
                  </i>
                </b-row>
              </template>
            </b-table>
          </div>
        </div>
        <div>
          <b-row>
            <b-col>
              <div>
                <span
                  class="pagination-indicator"
                >{{ currentFirstItem }}-{{ currentLastItem }} of {{ maxPage}} pages</span>
                <b-pagination
                  v-model="currentPage"
                  hide-goto-end-buttons
                  align="left"
                  size="md"
                  :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                  :limit="(totalPerPage > 0 ) ? 3 : 1"
                  :per-page="totalPerPage"
                  @change="getPurchasePackages"
                  class="custom-pagination-arrow-only mb-0 ml-2"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-bind:class="{ 'd-none': !viewList }">
        <h2 class="sub-heading mb-3">App Header</h2>
        <div>
          <div class="data-container" id="app-header-container">
            <b-table :fields="appHeaderFields" :items="appHeader">
              <template slot="image" slot-scope="data">
                <div id="app-header-image" class="border">
                  <img v-if="data.item.image !== ''" :src="data.item.image" alt="App Header Image" />
                </div>
              </template>
              <template slot="uuid" slot-scope="{}">
                <i class="action-button ml-2">
                  <img
                    src="@/assets/images/actions/edit.svg"
                    alt="Edit Button"
                    @click="callEditAppHeader()"
                  />
                </i>
              </template>
            </b-table>
          </div>
          <EditAppHeader
            :form="appHeaderDetails"
            :image="form.image"
            @clearImage="clearAppHeaderImg"
          ></EditAppHeader>
        </div>
      </div>
    </div>
    <b-modal id="edit-confirmation-modal" title="Confirm Edit" @shown="$refs.passwordForEdit.focus()">
      <b-form-group
        id="nameGroup"
        label="To edit this privilege card bundle, please enter your password"
        label-for="name"
        class="secondary-label mb-2"
      >
        <b-form-input
          id="name"
          type="password"
          v-model="passwordConfirmation"
          required
          maxlength="25"
          ref="passwordForEdit"
        ></b-form-input>
      </b-form-group>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          class="btn-cancel"
          style="margin-right: .25rem;"
          @click="hideModal('edit-confirmation-modal')"
        >Cancel</b-button>
        <b-button
          variant="primary"
          style="margin-left: .25rem;"
          v-bind:disabled="loading || (passwordConfirmation == '')"
          @click="callDisplay(editUuid)"
        >Yes</b-button>
      </div>
    </b-modal>
    <b-modal id="delete-modal" title="Confirm Delete" @shown="$refs.passwordForDelete.focus()">
      <p class="modal-main-message">
        Are you sure you want to delete
        <strong>{{ deletePurchasePackageName }}</strong>?
      </p>
      <b-form-group
        id="nameGroup"
        label="To delete this privilege card bundle, please enter your password"
        label-for="name"
        class="secondary-label mb-2"
      >
        <b-form-input
          id="name"
          type="password"
          v-model="passwordConfirmation"
          required
          maxlength="25"
          ref="passwordForDelete"
        ></b-form-input>
      </b-form-group>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          v-bind:disabled="loading"
          class="btn-cancel"
          style="margin-right: .25rem;"
          @click="hideModal('delete-modal')"
        >Cancel</b-button>
        <b-button
          variant="primary"
          v-bind:disabled="loading || (passwordConfirmation == '')"
          style="margin-left: .25rem;"
          @click="deletePurchasePackage"
        >
          <template v-if="loading">Deleting...</template>
          <template v-else>Yes, Delete</template>
        </b-button>
        <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
      </div>
    </b-modal>
    <b-modal
      id="packageUploadLogoStamp"
      title="Upload Image"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div id="logo-stamp-upload-container" class="border mx-auto rounded-circle">
        <croppa
          v-model="croppaLogoStamp"
          @new-image-drawn="onNewImageLogoStamp"
          @zoom="onZoomLogoStamp"
          :width="200"
          :height="200"
          placeholder="Choose an Image"
          :show-remove-button="true"
          :placeholder-font-size="14"
          remove-button-color="#ff8828"
        ></croppa>
      </div>
      <div id="logo-stamp-range-container" class="mx-auto mt-2">
        <input
          type="range"
          class="custom-range"
          id="customRange2"
          @input="onSliderChangeLogoStamp"
          :min="sliderMinLogoStamp"
          :max="sliderMaxLogoStamp"
          step=".001"
          v-model="sliderValLogoStamp"
        />
      </div>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          class="btn-cancel"
          @click="cancelUploadLogoStampModal(true)"
          style="margin-right: .25rem;"
        >Cancel</b-button>
        <b-button
          variant="primary"
          @click="hideUploadLogoStampModal(true)"
          style="margin-left: .25rem;"
        >Save</b-button>
      </div>
    </b-modal>
    <b-modal
      id="appHeaderUploadImage"
      title="Upload Image"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div id="app-header-image-upload-container" class="border mx-auto">
        <croppa
          v-model="croppa"
          @new-image-drawn="onNewImage"
          @zoom="onZoom"
          :width="350"
          :height="200"
          placeholder="Choose an Image"
          :show-remove-button="true"
          :placeholder-font-size="14"
          remove-button-color="#ff8828"
        ></croppa>
      </div>
      <div id="app-header-image-range-container" class="mx-auto mt-2">
        <input
          type="range"
          class="custom-range"
          id="customRange1"
          @input="onSliderChange"
          :min="sliderMin"
          :max="sliderMax"
          step=".001"
          v-model="sliderVal"
        />
      </div>
      <div slot="modal-footer">
        <b-button
          variant="ghost"
          class="btn-cancel"
          @click="cancelUploadImageModal(true)"
          style="margin-right: .25rem;"
        >Cancel</b-button>
        <b-button
          variant="primary"
          @click="hideUploadImageModal(true)"
          style="margin-left: .25rem;"
        >Save</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Switches from "vue-switches";
import { mapState } from "vuex";
import AddPurchasePackage from "@/components/privilege-card/AddPurchasePackage";
import EditPurchasePackage from "@/components/privilege-card/EditPurchasePackage";
import AddMembers from "@/components/privilege-card/AddMembers";
import EditAppHeader from "@/components/privilege-card/EditAppHeader";
import Members from "@/components/privilege-card/Members";
import MismatchRows from "@/components/privilege-card/MismatchRows";

export default {
  data() {
    return {
      currentPage: 1,
      viewList: true,
      selected: "Active in App",
      options: [{ value: "Active in App", text: "Active in App" }],
      fields: [
        { key: "title", label: "Package Type", sortable: true },
        { key: "no_members", label: "No. of Members", sortable: true },
        { key: "price", label: "Price", sortable: true },
        { key: "validity", sortable: true },
        { key: "visibility", label: "Status", sortable: true },
        { key: "uuid", label: "Action" },
      ],
      appHeaderFields: [
        { key: "image", label: "Background Image" },
        { key: "title" },
        { key: "uuid", label: "Action" },
      ],
      selectedPurchasePackage: "all",
      purchasePackageOptions: [
        { value: "all", text: "All Card Bundles" },
        { value: "active", text: "Active Cards" },
        { value: "inactive", text: "Inactive Cards" },
      ],
      form: {
        image: "",
        logoStamp: "",
      },
      croppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      croppaLogoStamp: {},
      sliderValLogoStamp: 0,
      sliderMinLogoStamp: 0,
      sliderMaxLogoStamp: 0,
      searchableFields: [
        { value: "all", text: "All" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" },
      ],
      searchKeyword: "",
      selectedSearchOption: "all",
      searchPayload: {
        keyword: "",
        filter: "",
      },
      purchasePackageUuid: null,
      deleteUuid: "",
      deletePurchasePackageName: "",
      editUuid: "",
      passwordConfirmation: "",
      mismatch: false,
    };
  },
  components: {
    Switches,
    AddPurchasePackage,
    EditPurchasePackage,
    Members,
    AddMembers,
    EditAppHeader,
    MismatchRows,
  },
  computed: {
    ...mapState("purchasePackages", [
      "purchasePackages",
      "members",
      "topPurchasePackages",
      "purchasePackageDetails",
      "appHeader",
      "appHeaderDetails",
      "loading",
      "maxPage",
      "nextPage",
      "prevPage",
      "totalPerPage",
      "currentFirstItem",
      "currentLastItem",
      "initialPageCount",
      "errors",
      "editing",
      "confirmationStatus",
      "data_errors",
    ]),
  },
  filters: {
    priceFormatter(value) {
      return Number.parseFloat(value).toFixed(2);
    },
    validityFormatter(value) {
      return (
        value.charAt(0).toUpperCase() + value.slice(1).replace(/.$/, "(s)")
      );
    },
  },
  created() {
    this.onSearchKeywordChange = _.debounce(() => {
      this.getPurchasePackages();
    }, 500);
    this.getPurchasePackages();
    this.getTopPurchasePackages();
    this.getAppHeader();
  },
  methods: {
    async getPurchasePackages(page = 1) {
      console.log(this.searchKeyword);
      this.currentPage = page;
      this.searchPayload = {
        keyword: this.searchKeyword,
        filter: this.selectedSearchOption,
      };

      await this.$store.dispatch("purchasePackages/getPurchasePackages", {
        page,
        payload: this.searchPayload,
      });
    },
    async getTopPurchasePackages() {
      await this.$store.dispatch("purchasePackages/getTopPurchasePackages");
    },
    async getAppHeader() {
      await this.$store.dispatch("purchasePackages/getAppHeader");
    },
    async exportPurchasePackages() {
      let param = {
        payload: {
          filter: this.selectedSearchOption,
          keyword: this.searchKeyword,
        },
      };

      await this.$store.dispatch(
        "purchasePackages/exportPurchasePackages",
        param
      );
    },
    async filterCardBundles() {
      let param = {
        page: 1,
        payload: {
          keyword: "",
          filter: this.selectedPurchasePackage,
        },
      };
      await this.$store.dispatch("purchasePackages/getPurchasePackages", param);
    },
    toggleViewList() {
      this.viewList = !this.viewList;
    },
    async showModal(modal) {
      (await (modal == "edit-modal"))
        ? this.$store.dispatch("purchasePackages/editing")
        : this.$store.dispatch("purchasePackages/resetEditing");

      this.$store.dispatch("purchasePackages/resetErrors");

      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    onNewImageLogoStamp() {
      // Logo Stamp
      this.sliderValLogoStamp = this.croppaLogoStamp.scaleRatio;
      this.sliderMinLogoStamp = this.croppaLogoStamp.scaleRatio / 2;
      this.sliderMaxLogoStamp = this.croppaLogoStamp.scaleRatio * 2;
    },
    onSliderChangeLogoStamp(evt) {
      let increment = evt.target.value;
      this.croppaLogoStamp.scaleRatio = +increment;
    },
    onZoomLogoStamp() {
      this.sliderValLogoStamp = this.croppaLogoStamp.scaleRatio;
    },
    cancelUploadLogoStampModal(forceClose = false) {
      this.clearPackageImgLogoStamp();
      if (forceClose) {
        this.hideModal("packageUploadLogoStamp");
        this.editing
          ? this.showModal("edit-modal")
          : this.showModal("new-purchase-package");
      }
      return true;
    },
    hideUploadLogoStampModal(forceClose = false) {
      if (this.croppaLogoStamp.generateDataUrl() === "") {
        return false;
      }

      this.form.logoStamp = this.croppaLogoStamp.generateDataUrl();

      if (forceClose) {
        this.hideModal("packageUploadLogoStamp");
        this.editing
          ? this.showModal("edit-modal")
          : this.showModal("new-purchase-package");
      }
      return true;
    },
    onNewImage() {
      this.sliderVal = this.croppa.scaleRatio;
      this.sliderMin = this.croppa.scaleRatio / 2;
      this.sliderMax = this.croppa.scaleRatio * 2;
    },
    onSliderChange(evt) {
      let increment = evt.target.value;
      this.croppa.scaleRatio = +increment;
    },
    onZoom() {
      this.sliderVal = this.croppa.scaleRatio;
    },
    cancelUploadImageModal(forceClose = false) {
      this.clearAppHeaderImg();
      if (forceClose) {
        this.hideModal("appHeaderUploadImage");
        this.showModal("edit-app-header");
      }
      return true;
    },
    hideUploadImageModal(forceClose = false) {
      if (this.croppa.generateDataUrl() === "") {
        return false;
      }

      this.form.image = this.croppa.generateDataUrl();

      if (forceClose) {
        this.hideModal("appHeaderUploadImage");
        this.showModal("edit-app-header");
      }
      return true;
    },
    clearAppHeaderImg() {
      this.form.image = "";
      this.croppa.remove();
    },
    clearPackageImgLogoStamp() {
      this.form.logoStamp = "";
      this.croppaLogoStamp.remove();
    },
    paginate(page) {
      return this.getPurchasePackages(page);
    },
    async callEditAppHeader() {
      this.showModal("edit-app-header");
    },
    showAddMembers(uuid) {
      this.purchasePackageUuid = uuid;
      this.showModal("new-members");
    },
    async showMembers(uuid) {
      this.purchasePackageUuid = uuid;
      this.$store.dispatch("purchasePackages/resetMembersPagination");

      let param = {
        page: 1,
        payload: {
          package_uuid: this.purchasePackageUuid,
          filter: "all",
        },
      };

      let _this = this;
      await this.$store
        .dispatch("purchasePackages/getMembers", param)
        .then(function () {
          _this.showModal("members");
        });
    },
    callDelete(uuid, purchasePackageName) {
      this.deleteUuid = uuid;
      this.deletePurchasePackageName = purchasePackageName;
      this.showModal("delete-modal");
    },
    async deletePurchasePackage() {
      let param = {
        password: this.passwordConfirmation,
      };

      let _this = this;
      await this.$store
        .dispatch("purchasePackages/confirmAction", param)
        .then(() => {
          if (_this.confirmationStatus) {
            this.hideModal("edit-confirmation-modal");
            this.$store
              .dispatch(
                "purchasePackages/deletePurchasePackage",
                _this.deleteUuid
              )
              .then(() => {
                _this.hideModal("delete-modal");
                if (_this.errors == null) _this.getPurchasePackages(1);
                _this.getTopPurchasePackages();
              });
          }
        });
    },
    async confirmEdit(uuid) {
      this.editUuid = uuid;
      this.showModal("edit-confirmation-modal");
    },
    async callDisplay(uuid) {
      let param = {
        password: this.passwordConfirmation,
      };

      let _this = this;

      await this.$store
        .dispatch("purchasePackages/confirmAction", param)
        .then(() => {
          if (_this.confirmationStatus) {
            this.hideModal("edit-confirmation-modal");
            this.$store
              .dispatch("purchasePackages/viewPurchasePackage", uuid)
              .then(function () {
                _this.showModal("edit-modal");
              });
          }
        });
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      this.passwordConfirmation = "";
    });
  },
  watch: {
    searchKeyword() {
      this.onSearchKeywordChange();
    },
    selectedSearchOption() {
      this.getPurchasePackages();
    },
    data_errors(value) {
      if (value !== null) {
        this.mismatch = true;
      } else {
        this.mismatch = false;
      }
    },
  },
};
</script>
